import { render } from "./AddRoleModal.vue?vue&type=template&id=33764e8e&scoped=true"
import script from "./AddRoleModal.vue?vue&type=script&lang=js"
export * from "./AddRoleModal.vue?vue&type=script&lang=js"

import "./AddRoleModal.vue?vue&type=style&index=0&id=33764e8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33764e8e"]])

export default __exports__